import { useReducer, useRef, useCallback, useEffect } from 'react';

function useCustomReducer(reducerFun, initialState, enableLogger) {
  const [state, dispatch] = useReducer(reducerFun, initialState);
  const preState = useRef();
  useCallback(action => {
    process.env.REACT_APP_ENV === "Dev" && console.log("Action passed to dispatch", action);
    const actionType = typeof action === "object" ? action.type : action;
    preState.current = {
      ...preState.current,
      actionType,
      action
    };
    dispatch(action);
  }, []);
  useEffect(() => {
    if (!enableLogger || !preState.current) return;
    const {
      actionType,
      state: previousState,
      action
    } = preState.current;
    process.env.REACT_APP_ENV === "Dev" && console.groupCollapsed(actionType ? "".concat(actionType) : "EDITOR REDUCER INVOKED");
    process.env.REACT_APP_ENV === "Dev" && console.log("%c Previous State", "color:orange", previousState);
    process.env.REACT_APP_ENV === "Dev" && console.log("%c Action", "color: blue", dispatch);
    process.env.REACT_APP_ENV === "Dev" && console.log("%c Current State", "color: green", state);
    process.env.REACT_APP_ENV === "Dev" && console.groupEnd();
  }, [state]);
  preState.current = {
    ...preState.current,
    state
  };
  return [state, dispatch];
}

export { useCustomReducer as u };
